"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BGM = exports.SFX = exports.VO = exports.DEFAULT = void 0;
exports.DEFAULT = "default";
exports.VO = "vo";
exports.SFX = "sfx";
exports.BGM = "bgm";
//# sourceMappingURL=AudioCategory.js.map